export const statusesForHiding = ['incomplete', 'not_saved', 'commit_to_mezzo', 'too_big', 'in_progress']
